<template>
  <div style="padding: 0 15px;" @click="toggleClick">
    <font-awesome-icon class="hamburger" :class="{'is-active':isActive}" :icon="['far', 'arrow-to-right']"/>
  </div>
</template>

<script>
export default {
  name: 'Hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleClick() {
      this.$emit('toggleClick')
    }
  }
}
</script>

<style scoped>
.hamburger {
  color: rgb(17, 24, 39);
  width: 25px;
  height: 25px;
  padding-top: 3px;
}

.hamburger.is-active{
  padding-bottom: 3px;
  padding-top: 0;
  transform: rotate(180deg);
}
</style>
